/**
 * Certification status stated per framework, in the words a GRC buyer checks.
 * "Ready" is not a status: each entry says whether an outside assessor has
 * looked at it yet. Update the row when the assessment happens, not before.
 */
export const CERTIFICATION_STATUS: { framework: string; status: string; detail: string }[] = [
  {
    framework: "CMMC Level 2",
    status: "Not assessed by a C3PAO.",
    detail: "Built to the practice set: tenant isolation, access control, audit logging and evidence retention. No certificate exists yet.",
  },
  {
    framework: "DCAA",
    status: "Supported, not accredited.",
    detail: "DCAA accredits contractor systems, not software. Odingard Studio keeps the auditable record a DCAA review asks your team to produce.",
  },
];
